import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- entities
import Product from 'PMT/entities/menu/Product';

// -- views

class ProductItem extends Component {

  static propTypes = {
    product: PropTypes.objectOf(Product).isRequired,

    isSelected: PropTypes.bool.isRequired,

    onToggle: PropTypes.func
  };

  onClick = () => {
    this.props.onToggle(this.product);
  };

  get product():Product {
    return this.props.product;
  }

  get isSelected(): boolean {
    return this.props.isSelected;
  }

  render() {
    return (
      <div
        className="product_item pointer"
        onClick={this.onClick}
      >
        {this.isSelected &&
          <i className="fa fa-check-square-o" />
        }
        {!this.isSelected &&
          <i className="fa fa-square-o" />
        }
        &nbsp;&nbsp;
        {this.product.name}
      </div>
    );
  }

}

export default ProductItem;



// WEBPACK FOOTER //
// ./scripts/components/restaurantMenu/chooseProductsModal/ProductItem.js